import { Col, Row, Typography } from "antd";
import { CSSProperties, MutableRefObject, useEffect, useState } from "react";
import image from "../../images/pos logo1 1.png";
import { getReceiptCurrLS, getReceiptLangLS } from "../../utils/main-utils";
import { useTranslation } from "react-i18next";
import toWords from 'number-to-words';
interface Props {
  componentRef: MutableRefObject<any>;
  data: any;
}

type SaleItem = {
  id: number;
  item: {
    id: number;
    name: string;
    barcode: string;
    category: {
      id: number;
      name: string;
      description: string;
    };
    description: string;
    image: null;
    sku: string;
    isActive: boolean;
  };
  quantity: number;
  cost: number;
  price: number;
  isTaxable: boolean;
  tax: number;
  discount: null;
  notes: string;
  isReturned: boolean;
  returnedQuantity: number;
  specifications: any[]; // You can replace `any` with a more specific type if you have information about the structure of `specifications`.
};

const HistoryPrinter = ({ data, componentRef }: Props) => {

  const subTitlesStyles: CSSProperties = {
    borderBottom: "1px #000 solid",
    textAlign: "center",
    fontWeight: "bold",
    fontSize: '10px'
  };

  const [username] = useState(localStorage.getItem("userName"));

  const taxRateString = localStorage.getItem("taxRate");
  const taxRate = taxRateString ? JSON.parse(taxRateString).taxRate : null;

  const mainCurrencyString = localStorage.getItem("mainCurrency");
  let mainCurrency = mainCurrencyString
    ? JSON.parse(mainCurrencyString)
    : null;

    
  const secondaryCurrencyString = localStorage.getItem("secondaryCurrency");
  let secondaryCurrency = secondaryCurrencyString
    ? JSON.parse(secondaryCurrencyString)
    : null;

  if(getReceiptCurrLS() === "lbp"){
    const temp = mainCurrency
    mainCurrency = secondaryCurrency
    secondaryCurrency = temp
  }

  const timestamp = data?.date;
  const date = new Date(timestamp * 1000);

  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear();

  const formattedDate = `${month.toString().padStart(2, "0")}/${day
    .toString()
    .padStart(2, "0")}/${year}`;

  const hours = date.getHours();
  const minutes = date.getMinutes();
  let period = "AM";

  if (hours >= 12) {
    period = "PM";
  }

  let formattedHours = hours % 12;
  formattedHours = formattedHours ? formattedHours : 12;

  const formattedTime = `${formattedHours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")} ${period}`;

  const totalItemQty = (): number => {
    let totalQty = 0;

    for (const item of data?.details) {
      totalQty += item.quantity;
    }
    return totalQty;
  };

  useEffect(() => {
    console.log('data', data)
  }, [data])

  const getFinalPrice = () => {
    let total = 0;
    data?.details.map((item: SaleItem) => {
      if (item.isTaxable) {
        total += item.price * item.quantity + item.price * taxRate;
      } else {
        total += item.price * item.quantity;
      }
      return null;
    });
    return total;
  };

  const [t] = useTranslation("common");
  const receiptLang = getReceiptLangLS()

  function numberWithCommas(x: number): any {
      return x === 0 ? '0.00' : x.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  }

  function numberWithCommasLBP(x: number) {
    return x && x.toFixed(0).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  }

  const receiptHeaderCompanyName = localStorage.getItem(
    "receiptHeaderCompanyName"
  );

  const receiptHeaderLocation = localStorage.getItem("receiptHeaderLocation");

  const receiptHeaderMOFNumber = localStorage.getItem("receiptHeaderMOFNumber");
  const companyPrimaryNumber = localStorage.getItem("companyPrimaryNumber");

  const itemStyles: CSSProperties = { borderBottom: "1px #000 dotted", fontSize: '10px' };
  const dataStyles: CSSProperties = { textAlign: "center", fontSize: '10px' };


  const convertToWords = ({ num, currency, subcurrency }: { num: number, currency: 'dollar' | 'lira', subcurrency: 'cent' | '' }) => {
    if(currency === 'lira') subcurrency = ''
    let wholePart = Math.floor(num);
    let fractionalPart = Math.round((num - wholePart) * 100);
    let wholePartWord = '', fractionalPartWord = '';
    wholePartWord = toWords.toWords(wholePart) + (wholePart === 1 ? ` ${currency}` : ` ${currency}s`);
    fractionalPartWord = fractionalPart > 0 ? ' and ' + toWords.toWords(fractionalPart) + (fractionalPart === 1 ? ` ${subcurrency}` : ` ${subcurrency}s`) : '';
    return wholePartWord + fractionalPartWord;
  };

  const countTaxableItems = data.details.reduce((curr: number, item: any) => {
    if (item?.isTaxable)
      return curr + 1;
    else
      return curr;
  }, 0);

  const leftColTable = {
    borderBottom: "1px #000 dotted",
    borderTop: "1px #000 solid",
    borderRight: "1px #000 solid",
    fontSize: '10px'
  };
  const RightColTable = {
    borderBottom: "1px #000 dotted",
    borderTop: "1px #000 solid",
    display: "flex",
    justifyContent: "center",
    fontSize: '10px'
  };

    function convertDateFormat(originalString: string) {
      // Split the original string into date and time parts
      var parts = originalString.split(" ");
      var datePart = parts[0];
      var timePart = parts[1];
  
      // Split the date part into day, month, and year
      var dateParts = datePart.split("/");
      var month = dateParts[0];
      var day = dateParts[1];
      var year = dateParts[2];
  
      // Concatenate the parts in the desired format
      var desiredString = day + "/" + month + "/" + year + " " + timePart;
  
      return desiredString;
  }

  return (
    <div ref={componentRef}
      dir={receiptLang === 'ar' ? "rtl" : "ltr"}
    >
      <Row justify={"center"}>
        <Typography.Title style={{ margin: 0 }} level={3}>
          {t('welcome', { lng: receiptLang })}
        </Typography.Title>
      </Row>

      <Row justify={"center"}>
        <Typography.Title style={{ margin: 0 }} level={2}>
          {receiptHeaderCompanyName === "null" ? "" : receiptHeaderCompanyName}
        </Typography.Title>
      </Row>

      <Row justify={"center"} style={{ marginBottom: "10px", fontSize: '10px' }}>
        <Col span={24} style={{ fontSize: '10px' }}> {data.customer?.name}</Col>
      </Row>

      <Row style={{ display: 'flex', flexDirection: 'column', marginBottom: "0.2rem" }}>
        <Col style={{ fontSize: '10px' }}>
          {receiptHeaderLocation === "null" ? "" : receiptHeaderLocation}
        </Col>
        <Col style={{ fontSize: '10px' }}>
          {t('phone', { lng: receiptLang })}: {companyPrimaryNumber === "null" ? "" : companyPrimaryNumber}
        </Col>
      </Row>

      <Row justify={"center"} gutter={[5, 0]} style={{ fontSize: '10px' }}>
        <Col span={13} style={{ fontSize: '10px' }}>{t('invoice', { lng: receiptLang })}#: {data?.invoiceNo}</Col>
        <Col span={11} style={{ fontSize: '10px' }}>
          {t('user', { lng: receiptLang })}: {username}
        </Col>
        <Col span={13} style={{ fontSize: '10px' }}>{t('register', { lng: receiptLang })}#: 01</Col>
        <Col span={11} style={{ fontSize: '10px' }}>
          {t('mof', { lng: receiptLang })}: {receiptHeaderMOFNumber === "null" ? "" : receiptHeaderMOFNumber}
        </Col>
      </Row>

      <Row justify={"center"} style={{ fontSize: '10px' }}>
        <Col span={11} style={subTitlesStyles}>
          {t('description', { lng: receiptLang })}
        </Col>
        <Col span={4} style={subTitlesStyles}>
          {t('qty', { lng: receiptLang })}
        </Col>
        <Col span={4} style={subTitlesStyles}>
          {t('u-price', { lng: receiptLang })}
        </Col>
        <Col span={5} style={subTitlesStyles}>
          {t('total', { lng: receiptLang })}
        </Col>
      </Row>

      {/* Map inside this section */}
      {data.details.map((item: any) => (
        <Row style={itemStyles}>
          <Col span={11} style={{ textAlign: "center", fontSize: "10px" }}>
            {item?.isTaxable ? "*" : ""}{item?.item.name}
          </Col>
          <Col span={4} style={dataStyles}>
            {item.quantity.toFixed(2)}
          </Col>
          <Col span={4} style={dataStyles}>
            {getReceiptCurrLS() === 'usd' ? numberWithCommas(item.price) : numberWithCommasLBP(item.price)}
          </Col>
          <Col span={5} style={dataStyles}>
            {getReceiptCurrLS() === 'usd' ? numberWithCommas(item.quantity * item.price): numberWithCommasLBP(item.quantity * item.price)}
          </Col>
        </Row>
      ))}

      {/* Map inside this section */}
      {data.discount ? (
        <Row justify={"end"} style={{ fontSize: '10px' }}>
          <Col span={6} style={{ fontSize: '10px' }}>{t('subtotal', { lng: receiptLang })} {mainCurrency?.symbol}:</Col>
          <Col span={5} style={{ fontSize: '10px' }}>{getReceiptCurrLS() === 'usd' ? numberWithCommas(Number(data?.subtotal)) : numberWithCommasLBP(Number(data?.subtotal))}</Col>
        </Row>
      ) : (
        ""
      )}

      {data.deliveryCharge ? (
        <Row justify={"end"} style={{ fontSize: '10px' }}>
          <Col span={6} style={{ fontSize: '10px' }}>{t('delivery', { lng: receiptLang })} {mainCurrency?.symbol}:</Col>
          <Col span={5} style={{ fontSize: '10px' }}>{getReceiptCurrLS() === 'usd' ? numberWithCommas(Number(data.deliveryCharge)) : numberWithCommasLBP(Number(data.deliveryCharge))}</Col>
        </Row>
      ) : (
        ""
      )}

      {data?.discount ? (
        <Row justify={"end"} style={{ fontSize: '10px' }}>
          <Col span={6} style={{ fontSize: '10px' }}>{t('discount', { lng: receiptLang })} {data?.discountType === "#" ? mainCurrency.symbol : "%"}:</Col>
          <Col span={5} style={{ fontSize: '10px' }}>{getReceiptCurrLS() === 'usd' ? numberWithCommas(data?.discount) : numberWithCommasLBP(data?.discount * data?.exchangeRate)}</Col>
        </Row>
      ) : (
        ""
      )}

      <Row justify={"end"} style={{ fontSize: '10px' }}>
        <Col span={6} style={{ fontSize: '10px' }}>{t('total', { lng: receiptLang })} {mainCurrency?.symbol}:</Col>
        <Col span={5} style={{ fontSize: '10px' }}>{getReceiptCurrLS() === 'usd' ? numberWithCommas(Number(data.amount)): numberWithCommasLBP(Number(data.amount))}</Col>
      </Row>

      <Row justify={"end"} style={{ fontSize: '10px' }}>
        <Col span={6} style={{ fontSize: '10px' }}>{t('rate', { lng: receiptLang })}:</Col>
        <Col span={5} style={{ fontSize: '10px' }}>{numberWithCommasLBP(data.exchangeRate)}</Col>
      </Row>

      <Row justify={"end"} style={{ fontSize: '10px' }}>
        <Col span={6} style={{ fontSize: '10px' }}>{t('total', { lng: receiptLang })} {secondaryCurrency?.symbol}:</Col>
        <Col span={5} style={{ fontSize: '10px' }}>
          {getReceiptCurrLS() === 'lbp' ? numberWithCommas(Number(data.amount) / data.exchangeRate) : numberWithCommasLBP(Number(data.amount) * data.exchangeRate)}
        </Col>
      </Row>
      <Row style={{ display: "flex", gap: "5px", marginBottom: "10px", justifyContent: "flex-start", fontSize: '10px' }}>
        <Col>
          <Col style={{ fontSize: '10px' }}>{t('only', { lng: receiptLang })} {data?.amount && convertToWords({
            num: Number(data?.amount),
            currency: getReceiptCurrLS() === 'lbp' ? 'lira' : 'dollar',
            subcurrency: 'cent'
          })}</Col>
        </Col>
      </Row>

      <Row justify={"start"} style={{ fontSize: '10px' }}>
        <Col span={8} style={{ fontSize: '10px' }}>*{t('tax-included', { lng: receiptLang })}: {countTaxableItems}</Col>
      </Row>

      <Row justify={"start"} style={{ fontSize: '10px' }}>
        <Col style={{ fontSize: '10px' }}>{t("total-vat", { lng: receiptLang })} 11%: {data.vat} {mainCurrency.symbol}</Col>
      </Row>

      <Row justify={"center"} style={{ fontSize: '10px' }}>
        <Col span={12} style={{ textAlign: "center", fontSize: '10px' }}>
          {t('payment-type', { lng: receiptLang })}
        </Col>
        <Col span={12} style={{ textAlign: "center", fontSize: '10px' }}>
          {t('value', { lng: receiptLang })}
        </Col>
        <Col span={12} style={leftColTable}>
          {t('cash', { lng: receiptLang })} {mainCurrency?.symbol}:
        </Col>
        <Col span={12} style={RightColTable}>
          {/* {numberWithCommas(
            data.paidAmount
          ) ?? 0} */}
          {getReceiptCurrLS() === 'usd' ? numberWithCommas(data.amount) : numberWithCommasLBP(data.amount)}
        </Col>
        <Col span={12} style={leftColTable}>
          {t('change', { lng: receiptLang })} {mainCurrency?.symbol}:
        </Col>
        <Col span={12} style={RightColTable}>
          {getReceiptCurrLS() === 'usd' ? numberWithCommas(0): numberWithCommasLBP(0)}
        </Col>
      </Row>

      <Row justify={"start"} style={{ fontSize: '10px' }}>
        <Col span={9} style={{ fontSize: '10px' }}>{t('dead-balance', { lng: receiptLang })}: </Col>
        <Col span={3} style={{ fontSize: '10px' }}>{getReceiptCurrLS() === 'usd' ? numberWithCommas(data.deadBalance) : numberWithCommasLBP(data.deadBalance)}</Col>
      </Row>

      <Row justify={"start"} style={{ fontSize: '10px' }}>
        <Col span={9} style={{ fontSize: '10px' }}>#{t('items', { lng: receiptLang })}:</Col>
        <Col span={3} style={{ fontSize: '10px' }}>{totalItemQty().toFixed(2)}</Col>
      </Row>

      <Row justify={"start"} >
        <Col style={{ fontSize: '10px' }}>{t('date', { lng: receiptLang })}: {convertDateFormat(data?.date)}</Col>
      </Row>

      <Row justify={"center"} style={{ fontSize: '10px' }}>
        <Typography.Title level={3} style={{ fontSize: '14px', marginTop: '2rem' }}>{t('thank-you', { lng: receiptLang })}</Typography.Title>
        <Row justify={"center"} style={{ fontSize: '10px' }}>
          <img src={image} alt="" width={83.2} />
        </Row>
      </Row>
    </div>
  );
};

export default HistoryPrinter;
